import { Icon } from '@iconify/react';
import PageBanner from '../components/layout/PageBanner';
import AnimatedSection from '../components/ui/AnimatedSection';

export default function Contacto(){
    return(
    <main className="bg-[#f5f5f7] text-[#2d2d44]">
            <PageBanner
              titulo="Contacto"
              crumbs={[
                { label: 'Inicio', href: '/' },
                { label: 'Contacto' },
              ]}
            />
            <div className="max-w-4xl mx-auto px-4 py-12">
                <AnimatedSection className="text-center max-w-lg mx-auto">
                    <AnimatedSection animation="scale-in">
                        <div className="w-16 h-16 rounded-2xl bg-[#f26724]/10 border border-[#f26724]/20 flex items-center justify-center mx-auto mb-6">
                            <Icon icon="mdi:hand-wave" className="text-3xl text-[#f26724]" />
                        </div>
                    </AnimatedSection>
                    <h2 className="text-3xl md:text-4xl font-bold text-[#f26724] mb-3">Agenda una reunión gratuita</h2>
                    <p className="text-lg text-gray-500 mb-8 leading-relaxed">
                        Descubre cómo podemos automatizar tus procesos y ayudarte a vender más. Sin compromiso.
                    </p>
                    
                    <div className="space-y-4 mb-8">
                        <a href="https://api.whatsapp.com/send?phone=51946564003&text=Quiero%20agendar%20una%20reuni%C3%B3n%20gratuita" className="flex items-center justify-center gap-3 w-full px-8 py-4 bg-[#25D366] text-white font-semibold rounded-xl hover:bg-[#20bd5a] transition-all hover:shadow-lg hover:shadow-green-500/20" target="_blank" rel="noopener noreferrer">
                            <Icon icon="mdi:whatsapp" className="text-2xl" />
                            Agenda por WhatsApp
                        </a>
                        <a href="mailto:gian.gomez@scalar.pe" className="flex items-center justify-center gap-3 w-full px-8 py-4 border-2 border-black/20 text-gray-600 font-semibold rounded-xl hover:bg-black/5 hover:border-black/40 transition-all">
                            <Icon icon="mdi:email" className="text-2xl" />
                            Escríbenos por correo
                        </a>
                    </div>

                    <hr className="border-black/10 mb-8" />

                    <AnimatedSection animation="fade-in" delay={200}>
                        <div className="text-left max-w-xs mx-auto space-y-4">
                            <h5 className="text-[#f26724] font-semibold text-center mb-4">Otros canales de contacto</h5>
<AnimatedSection animation="fade-in-left" delay={100} className="flex items-center gap-3 text-gray-700">
                                <Icon icon="mdi:email" className="text-[#f26724] text-xl" />
                                <a className="hover:text-[#f26724] transition-colors text-sm" href="mailto:gian.gomez@scalar.pe">gian.gomez@scalar.pe</a>
                            </AnimatedSection>
                            <AnimatedSection animation="fade-in-left" delay={200} className="flex items-center gap-3 text-gray-700">
                                <Icon icon="mdi:email" className="text-[#f26724] text-xl" />
                                <a className="hover:text-[#f26724] transition-colors text-sm" href="mailto:angel.torre@scalar.pe">angel.torre@scalar.pe</a>
                            </AnimatedSection>
                            <AnimatedSection animation="fade-in-left" delay={300} className="flex items-center gap-3 text-gray-700">
                                <Icon icon="mdi:phone" className="text-[#f26724] text-xl" />
                                <a className="hover:text-[#f26724] transition-colors text-sm" href="tel:51930431035">930 431 035</a>
                            </AnimatedSection>
                            <AnimatedSection animation="fade-in-left" delay={400} className="flex items-center gap-3 text-gray-700">
                                <Icon icon="mdi:phone" className="text-[#f26724] text-xl" />
                                <a className="hover:text-[#f26724] transition-colors text-sm" href="tel:51933390084">933 390 084</a>
                            </AnimatedSection>
                        </div>
                    </AnimatedSection>
                </AnimatedSection>
            </div>
    </main>
    )
}
